/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type editor_editorProperties$ref: FragmentReference;
export type editor_editorProperties = {|
  +rtlSupport: ?boolean,
  +newCkeditor: ?boolean,
  +ckeditor5: ?boolean,
  +ckeditor5AiEnabled: ?boolean,
  +newSpellcheckEnabled: ?boolean,
  +newSpellcheckTenantDictionaryName: ?string,
  +ckeditor5LicenseKey: ?string,
  +contentDirection: ?string,
  +$refType: editor_editorProperties$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "editor_editorProperties",
  "type": "DocumentEditType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rtlSupport",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newCkeditor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5AiEnabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newSpellcheckEnabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "newSpellcheckTenantDictionaryName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ckeditor5LicenseKey",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentDirection",
      "args": null,
      "storageKey": null
    }
  ]
};

(node/*: any*/).hash = '1e868048348192e90e60baf759cbf2de';
module.exports = node;
